// Preserve Google Forms' native "other" answer contract without claiming delivery.
// Delegation survives Shopify section re-rendering; registration is idempotent.
if (!window.fdCountryFormReady) {
  window.fdCountryFormReady = true;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-fd-country-form]')) return;
    const other = form.querySelector('[data-fd-other-fragrance]');
    const trigger = form.querySelector('[data-fd-other-trigger]');
    if (other && trigger) trigger.disabled = !other.value.trim();
  });
}
